import React, { useContext } from 'react'
import { IconContext } from 'react-icons'
import {
    FaMousePointer,
    FaTimesCircle,
    FaVectorSquare,
    FaDrawPolygon,
    FaInfoCircle,
    FaLayerGroup,
    FaRuler,
    FaFilter,
    FaTimes,
} from 'react-icons/fa'
import { MdFormatShapes } from 'react-icons/md'

import { IconTooltip as Tooltip } from '../../../elem/Tooltip'
import { MapControlContext } from './MapControlContext'
import { DataContext } from './DataContext'
import { AppStateContext } from '../AppStateContext'
import { PanelStyleContext } from '../../../elem/panel/PanelStyleContext'
import withConfig from '../../../wrappers/withConfig'
import MeasureSelect from './header-controls/MeasureSelect'

const MapHeaderControls = ({ config }) => {
    const {
        mapState: { selectedFeatures, mapSelectionIds },
        setMapState,
    } = useContext(AppStateContext)
    const { backgroundColorClass, borderClass, headerIconClass } = useContext(
        PanelStyleContext
    )
    const {
        activeControl,
        activateControl,
        clearControls,
        displayTooltip,
        toggleTooltip,
        displayMapLayers,
        toggleMapLayers,
    } = useContext(MapControlContext)
    const { clearSelectionLayer } = useContext(DataContext)
    const { FACILITY_TITLE, ID_COLUMN } = config

    const controls = [
        {
            icon: FaMousePointer,
            name: 'select',
            tooltip: `Select ${FACILITY_TITLE}s by Click`,
        },
        {
            icon: FaVectorSquare,
            name: 'boundingBox',
            tooltip: `Select ${FACILITY_TITLE}s by Rectangle`,
        },
        {
            icon: FaDrawPolygon,
            name: 'polygon',
            tooltip: `Select ${FACILITY_TITLE}s by Polygon`,
        },
        {
            icon: FaRuler,
            name: 'measure',
            tooltip: 'Measure Distance',
        },
        {
            icon: MdFormatShapes,
            name: 'measureArea',
            tooltip: 'Measure Area',
        },
    ]

    return (
        <div className="panelHeaderControls">
            <div
                id="distanceUnitDiv"
                className={`is-small ${
                    activeControl &&
                    (activeControl === 'measure' ||
                        activeControl === 'measureArea')
                        ? ''
                        : 'is-hidden'
                }`}
            >
                <MeasureSelect control={activeControl} />
            </div>
            <div className="panelHeaderIconWrapper">
                <button
                    disabled={!(selectedFeatures && selectedFeatures.length)}
                    className={`button is-small panelHeaderIconDiv ${borderClass} ${backgroundColorClass} ${headerIconClass} displayIcon`}
                    onClick={() => {
                        setMapState(prevState => ({
                            ...prevState,
                            mapSelectionIds: selectedFeatures
                                .map(x => x.get(ID_COLUMN))
                                .join(','),
                        }))
                    }}
                >
                    <span className="icon is-small">
                        <IconContext.Provider
                            value={{ className: `panelHeaderIcon inactive` }}
                        >
                            <FaFilter />
                        </IconContext.Provider>
                    </span>
                    <span>Filter by Map Selection</span>
                </button>
                <button
                    disabled={mapSelectionIds === null || mapSelectionIds === ''}
                    className={`button is-small panelHeaderIconDiv ${borderClass} ${backgroundColorClass} ${headerIconClass} displayIcon`}
                    onClick={() => {
                        setMapState(prevState => ({
                            ...prevState,
                            mapSelectionIds: '',
                        }))
                    }}
                >
                    <span className="icon is-small">
                        <IconContext.Provider
                            value={{ className: `panelHeaderIcon inactive` }}
                        >
                            <FaTimes />
                        </IconContext.Provider>
                    </span>
                    <span>Remove Map Filter</span>
                </button>
                <div className="controlsGroupedWrapper">
                    {controls.map((control, idx) => {
                        const { name, icon: Icon, tooltip } = control
                        return (
                            <div
                                key={`icon-${idx}`}
                                className={`panelHeaderIconDiv displayIcon ${
                                    activeControl === name
                                        ? 'active'
                                        : 'inactive'
                                }`}
                                data-tip={`${tooltip}`}
                                data-for={`${name}`}
                            >
                                <IconContext.Provider
                                    value={{
                                        className: `panelHeaderIcon ${
                                            activeControl === name
                                                ? 'active'
                                                : 'inactive'
                                        }`,
                                    }}
                                >
                                    <Icon
                                        onClick={() => {
                                            if (activeControl === name) {
                                                clearControls()
                                            } else {
                                                activateControl(name)
                                            }
                                        }}
                                    />
                                </IconContext.Provider>
                                <Tooltip id={name} />
                            </div>
                        )
                    })}
                </div>
                <div
                    className={`panelHeaderIconDiv displayIcon ${
                        displayTooltip ? 'active' : 'inactive'
                    }`}
                    data-for={'displayTooltip'}
                    data-tip={'Display / Hide Tooltip'}
                >
                    <IconContext.Provider
                        value={{
                            className: `panelHeaderIcon ${
                                displayTooltip ? 'active' : 'inactive'
                            }`,
                        }}
                    >
                        <FaInfoCircle
                            onClick={() => {
                                toggleTooltip(!displayTooltip)
                            }}
                        />
                    </IconContext.Provider>
                    <Tooltip id={'displayTooltip'} />
                </div>
                <div
                    className="panelHeaderIconDiv"
                    data-for={'clearSelection'}
                    data-tip={'Clear Selection'}
                >
                    <IconContext.Provider
                        value={{
                            className: 'mapIcon inactive',
                        }}
                    >
                        <FaTimesCircle
                            onClick={() => {
                                clearControls()
                                clearSelectionLayer()
                            }}
                        />
                    </IconContext.Provider>
                    <Tooltip id={'clearSelection'} />
                </div>
                <div
                    className="panelHeaderIconDiv"
                    data-for={'displayLayers'}
                    data-tip={'Display / Hide Layers'}
                >
                    <IconContext.Provider
                        value={{ className: 'panelHeaderIcon' }}
                    >
                        <FaLayerGroup
                            onClick={() => {
                                toggleMapLayers(!displayMapLayers)
                            }}
                        />
                    </IconContext.Provider>
                    <Tooltip id={'displayLayers'} />
                </div>
            </div>
        </div>
    )
}

export default withConfig(MapHeaderControls)
